export default {
  label: {
    blockchain: '区块链',
    wallet: '钱包地址',
    agentNo: '代理号',
    usdtAmount: 'USDT金额',
    usdtFee: 'USDT手续费',
    modify: '修改USDT账号信息',
    delete: '删除该账号',
    withdrawCount: '提款数量',
    submitAmount: '提交金额USDT',
    submitVndAmount: '提交金额VND',
    successAmount: '成功金额',
    exchangeRate: '系统汇率',
    copy: '复制'
  },
  rules: {
    blockchain: '区块链不能为空',
    wallet: '钱包地址不能为空',
    type: '提现金额必须为数字',
    min: '提现金额必须大于100',
    max: '提现金额不能大于余额'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/usdt.js